import env, { type IichiEnv, type User, type Member, type Shop, type Topic } from './_env';
import { pinia } from './store';
import { useShopStore } from './store/shop';
import { useUserStore } from './store/user';

export { IichiEnv } from './_env';
export { CdnDomain } from './_config';

interface BaseOptions {
  iichiEnv: IichiEnv;
  User: User;
  Topics?: Topic[];
}
type Options = BaseOptions | (BaseOptions & { Member: Member; Shop: Shop });

export class Common {
  public env: typeof env;

  constructor() {
    this.env = env;
  }

  initialize(options: Options) {
    const userStore = useUserStore(pinia);
    const shopStore = useShopStore(pinia);
    userStore.updateCredential(options.User.credentials);
    if ('Member' in options) {
      userStore.assignMember(options.Member);
      userStore.updatePermission(options.Member.permissions);
      shopStore.assignShop(options.Shop);
    }
  }
}

// 同一インスタンスを使用するためwindow下に保持
const common = window.common === undefined ? new Common() : window.common;
window.common = common;

export default common;
